import { Doughnut } from 'react-chartjs-2';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import styles from 'styles/components/pages/professor/statistics/DoughnutChart.module.scss';

const backgroundColor = [
  STYLES_VARIABLES.GREEN_01,
  STYLES_VARIABLES.GREEN_02,
  STYLES_VARIABLES.BLUE,
  STYLES_VARIABLES.YELLOW,
  STYLES_VARIABLES.RED_01,
];

const labels = ['매우 우수', '우수', '보통', '낮음', '매우 낮음'];

const customLegend = (
  <div className={styles.legend_wrapper}>
    {backgroundColor.map((color, index) => (
      <div className={styles.legend_item} key={index}>
        <span
          className={styles.legend_color}
          style={{ backgroundColor: color }}
        ></span>
        <span className={styles.legend_text}>{labels[index]}</span>
      </div>
    ))}
  </div>
);

type TProps = {
  totalCount: number;
  data: number[];
  percent: number[];
};

const DoughnutChart = ({ totalCount, data, percent }: TProps) => {
  const sum = data.reduce((accumulator, currentValue) => {
    return accumulator + currentValue;
  }, 0);

  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor,
        borderWidth: 0,
        cutout: '62.81%',
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
    },
  };

  return (
    <div className={styles.section}>
      <h2 className={styles.title}>학생 종합 평가 점수</h2>
      <div className={styles.section1_wrapper}>
        {/* 도넛 그래프 */}
        <div className={styles.doughnut_chart_wrapper}>
          <div className={styles.doughnut_wrapper}>
            {sum > 0 ? (
              <Doughnut
                width={280}
                height={280}
                data={chartData}
                options={options}
              />
            ) : (
              <div className={styles.doughnut_disabled} />
            )}
            <dl>
              <dt>전체 학생</dt>
              <dd>{totalCount ? `${totalCount}명` : '-'}</dd>
            </dl>
          </div>
          {customLegend}
        </div>
        {/* 테이블 */}
        <table>
          <thead>
            <tr className={styles.tr}>
              <th className={styles.table_title}>해당 학생 (명/전체)</th>
              <th className={styles.table_title}>비율 (%)</th>
            </tr>
          </thead>
          <tbody>
            {labels.map((_, index) => (
              <tr className={styles.tr} key={index}>
                <th className={styles.table_column}>
                  {totalCount > 0 ? `${data[index] || 0} / ${totalCount}` : '-'}
                </th>
                <th className={styles.table_column}>
                  {totalCount > 0 ? `${percent[index] || 0}%` : '-'}
                </th>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DoughnutChart;
